import Cookies from 'js-cookie';

// Tracking cookies
// Mainly for ODO/legacy support, can be likely retired when ODO is

// Landing page cookie
const landingPage = Cookies.get('odcUIDLandingPage');

if (!landingPage) {
  Cookies.set('odcUIDLandingPage', window.location.href); // expires at end of browser session
}

// UTM cookies
function setUTMCookies(key, param, options = {}) {
  const now = new Date().getTime();
  const isUrl = options.isUrl || false;
  const params = new URL(document.location).searchParams;

  // Timestamp handling
  if (key === 'timestamp') {
    let originalTimestamp = Cookies.get('ondeck_original_timestamp');
    let convertingTimestamp = Cookies.get('ondeck_converting_timestamp');
    if (typeof originalTimestamp === 'undefined') {
      originalTimestamp = now;
      Cookies.set('ondeck_original_timestamp', originalTimestamp, { expires: 365 });
    }
    if (typeof convertingTimestamp === 'undefined') {
      convertingTimestamp = now;
      Cookies.set('ondeck_converting_timestamp', convertingTimestamp);
    }
    return;
  }

  // Value from param or URL
  let convertingValue = isUrl ? window.location.href : params.get(param);
  let originalValue = Cookies.get(`ondeck_original_${key}`);

  // Set converting cookie
  if (convertingValue !== null && typeof convertingValue !== 'undefined') {
    Cookies.set(`ondeck_converting_${key}`, convertingValue);
  } else {
    convertingValue = Cookies.get(`ondeck_converting_${key}`);
  }

  // Set original cookie if not set
  if (typeof originalValue === 'undefined' && typeof convertingValue !== 'undefined') {
    originalValue = convertingValue;
    Cookies.set(`ondeck_original_${key}`, originalValue, { expires: 365 });
  }
}

// Set cookies
setUTMCookies('timestamp');
setUTMCookies('source', 'utm_source');
setUTMCookies('medium', 'utm_medium');
setUTMCookies('content', 'utm_content');
setUTMCookies('campaign', 'utm_campaign');
setUTMCookies('term', 'utm_term');
setUTMCookies('landing_page', null, { isUrl: true });
